import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=3c1b769c&scoped=true&"
import script from "./InvitePage.vue?vue&type=script&lang=ts&"
export * from "./InvitePage.vue?vue&type=script&lang=ts&"
import style0 from "./InvitePage.vue?vue&type=style&index=0&id=3c1b769c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b769c",
  null
  
)

export default component.exports